export type AuthMode = "login" | "register";

export type AuthErrorTranslationKey =
  | "authEmailAlreadyRegistered"
  | "authEmailNotConfirmed"
  | "authLoginError"
  | "authRegisterError"
  | "authSignupDisabled";

function getErrorCode(error: unknown) {
  if (typeof error !== "object" || error === null || !("code" in error)) {
    return null;
  }

  return typeof error.code === "string" ? error.code : null;
}

export function getAuthErrorTranslationKey(
  error: unknown,
  mode: AuthMode
): AuthErrorTranslationKey {
  const code = getErrorCode(error);

  if (mode === "login") {
    return code === "email_not_confirmed"
      ? "authEmailNotConfirmed"
      : "authLoginError";
  }

  if (code === "signup_disabled") {
    return "authSignupDisabled";
  }

  if (code === "user_already_exists") {
    return "authEmailAlreadyRegistered";
  }

  return "authRegisterError";
}
